import React, { FC } from 'react';
import { ModuleType } from './CardHeader';
import { useNavigate } from 'react-router-dom';
import { EndPoints } from '../../../../../utils/apiEndpoints';
import { useUserStore } from '../../../../../store/useUserStore';
import { darkModeBackgroud } from '../../../../../utils/constants';
import { useDarkModeStore } from '../../../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../../../store/useLanguageStore';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ToastMessage from '../../../../../common/ToastMessage';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import useDeleteTicket from '../../../../../store/ReactQueries/tickets/useDeleteTicket';
import useDeleteAsset from '../../../../../store/ReactQueries/assets/asset/useDeleteAsset';

const btnCss = { width: 15, height: 15 };

interface ButtonInterface {
    id: number;
    name: string;
    icon: JSX.Element;
    description: string;
    handleClick: () => void;
}

interface CardHeaderBtnProps {
    page: number;
    pageSize: number;
    selectedIds: string[];
    module: ModuleType;
}
export const CardHeaderBtn: FC<CardHeaderBtnProps> = ({ module, selectedIds, page, pageSize }) => {
    const navigation = useNavigate();
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const { user } = useUserStore();
    const role =
        user?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

    const isEmployee = role === "Employee";

    const deleteAsset = useDeleteAsset(page, pageSize);
    const deleteTicket = useDeleteTicket(page, pageSize);

    const isDisabled = selectedIds.length === 0;

    const handleDelete = async () => {
        let allSuccess = true;
        if (await ToastMessage.Confirm(language['ToastDeleteItem'])) {
            await Promise.all(
                selectedIds.map(async (id) => {
                    return new Promise((resolve) => {
                        if (module === 'Assets') {
                            deleteAsset.mutate(id, {
                                onSuccess: () => resolve(true),
                                onError: () => {
                                    allSuccess = false;
                                    resolve(false);
                                }
                            });
                        } else if (module === 'Tickets') {
                            deleteTicket.mutate(id, {
                                onSuccess: () => resolve(true),
                                onError: () => {
                                    allSuccess = false;
                                    resolve(false);
                                }
                            });
                        }
                    });
                })
            );
        }
        if (allSuccess) ToastMessage.Success();
        else ToastMessage.Failed();
    };

    const handleNewAsset = () => {
        if (module === 'Assets') navigation(EndPoints.ADDASSET);
        else if (module === 'Tickets') navigation(EndPoints.ADDTICKET);
        else navigation('/');
    }

    let buttons: ButtonInterface[] = [
        { id: 7, name: 'Delete', icon: <DeleteOutlineIcon sx={btnCss} />, description: 'DeleteAsset', handleClick: handleDelete },
        { id: 8, name: 'New', icon: <AddCircleOutlineIcon sx={btnCss} />, description: 'NewAsset', handleClick: handleNewAsset },
    ];
    if (isEmployee) {
        buttons = buttons.filter(item => item.name !== 'New');
    }

    return (
        <div className='d-flex flex-row align-items-center gap-1' style={{ background: darkMode ? darkModeBackgroud : '#FCFCFD' }}>
            {
                buttons.map(btn =>
                    <div key={btn.id} title={language[btn.description]}>
                        <Stack direction="row" spacing={1}>
                            <Button
                                variant="outlined"
                                disabled={isDisabled && btn.name !== 'New'}
                                startIcon={btn.icon}
                                sx={{
                                    color: darkMode ? 'white' : '#183247',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    border: `1px solid ${darkMode ? 'white' : '#CFD7DF'}`,
                                    fontSize: 13,
                                    '&.Mui-disabled': {
                                        color: darkMode ? 'white' : 'initial',
                                        borderColor: darkMode ? '#7a7a7a' : 'initial',
                                    },
                                }}
                                onClick={btn.handleClick}
                            >
                                {language[btn.name]}
                            </Button>
                        </Stack>
                    </div>
                )
            }
        </div>
    );
};
